import {
  GET_SHIPPINGS_LIST_IN_PROGRESS,
  GET_SHIPPINGS_LIST_SUCCESS,
  GET_SHIPPINGS_LIST_FAIL,
  GET_SHIPPINGS_FILTERS_IN_PROGRESS,
  GET_SHIPPINGS_FILTERS_SUCCESS,
  GET_SHIPPINGS_FILTERS_FAIL,
  GET_SHIPPINGS_COUNT_IN_PROGRESS,
  GET_SHIPPINGS_COUNT_SUCCESS,
  GET_SHIPPINGS_COUNT_FAIL,
} from "../constants";
import { LOGOUT } from "../../authentication/constants";

const initialState = {
  list: [],
  inProgress: false,
  error: false,
  listCalled: false,
  filters: [],
  filtersInProgress: false,
  count: 0,
  countInProgress: false,
};

/**
 * Shipping reducer
 *
 * @param {Object} state
 * @param {Object} action
 *
 * @return {Object}
 */
export default function shippings(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case GET_SHIPPINGS_LIST_IN_PROGRESS:
      return {
        ...state,
        inProgress: true,
        error: false,
        listCalled: true,
      };

    case GET_SHIPPINGS_LIST_SUCCESS:
      return {
        ...state,
        list: payload.list,
        inProgress: false,
      };

    case GET_SHIPPINGS_LIST_FAIL:
      return {
        ...state,
        inProgress: false,
        error: true,
      };

    case GET_SHIPPINGS_FILTERS_IN_PROGRESS:
      return {
        ...state,
        filtersInProgress: true,
        error: false,
      };

    case GET_SHIPPINGS_FILTERS_SUCCESS:
      return {
        ...state,
        filters: payload.filters,
        filtersInProgress: false,
      };

    case GET_SHIPPINGS_FILTERS_FAIL:
      return {
        ...state,
        filtersInProgress: false,
        error: true,
      };

    case GET_SHIPPINGS_COUNT_IN_PROGRESS:
      return {
        ...state,
        countInProgress: true,
        error: false,
      };

    case GET_SHIPPINGS_COUNT_SUCCESS:
      return {
        ...state,
        count: payload.count,
        countInProgress: false,
      };

    case GET_SHIPPINGS_COUNT_FAIL:
      return {
        ...state,
        countInProgress: false,
        error: true,
      };

    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };

    default:
      return state;
  }
}
